<template>
  <div class="feeD-con">
    <div class="feeInfos">
      <img
        src="../assets/imgs/zaiceB.png"
        alt=""
        v-if="isZaice"
      >
      <img
        src="../assets/imgs/buzaiceB.png"
        alt=""
        v-if="!isZaice"
      >
      <div class="feeTit">
        <p>{{orderObj.title}}</p>
        <p>￥{{orderObj.money}}</p>
      </div>
      <div class="finfo">
        <p>{{orderObj.remark}} </p>
        <p>学员需在有效期内完成大纲学时的学习。若未完成大纲学时，下一期需要重新缴费学习。</p>
      </div>
    </div>
    <div
      class="btnPay"
      @click="toPay"
    >立即购买</div>
  </div>
</template>
<script>
import { sureOrder } from '../../src/api/Api'
import { Toast } from 'mint-ui'
export default {
  data () {
    return {
      orderObj: {},
      isZaice: sessionStorage.getItem('rigister')
    }
  },
  created () {
    this.toSureOrder()
  },
  methods: {
    toSureOrder () {
      sureOrder({
        courseId: '1212'
      }).then(res => {
        if (res.data.returnCode === 1) {
          this.orderObj = res.data.returnDate
        } else {
          Toast(res.data.returnMsg)
        }
      })
    },
    toPay () {
      this.$router.push({
        path: '/pay'
      })
    }
  }
}
</script>
<style>
#app .feeD-con {
  background: #fff;
  height: auto;
}
.feeInfos img {
  width: 100%;
  height: 2.98rem;
  display: block;
}
.feeTit {
  padding: 0.2rem 0.4rem;
  font-size: 0.38rem;
  line-height: 0.6rem;
  border-bottom: 0.2rem solid #f1f1f1;
}
.finfo {
  padding: 0.4rem;
  color: #666;
  line-height: 0.4rem;
}
.finfo p {
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/FeeDetail.vue